export default __webpack_public_path__ + "static/media/office.0a402592.png";